import { combineReducers } from 'redux';
import login from './login/login';
import pageFooter from '../shared/reducers/pageFooter/pageFooter';
import errorStatus from '../shared/reducers/errorStatus/errorStatus';
import loginParams from '../slices/loginParams/loginParams';

export default combineReducers({
    login,
    pageFooter,
    errorStatus,
    loginParams,
});
